// 语言选择列表
export default class I18nUtils {
    static langList =  [
        { id: "en", name: "English" },
        { id: "zh", name: "简体中文" },
        { id: "zh_Hant", name: "繁体中文" },
        { id: "vi", name: "tiếng Việt" },
        // { id: "es", name: "Español" },
        // { id: "he", name: "עִבְרִית" },
    ];

    static initLanguage(page) {
        let lang  = page.$route.query.language  //优先
                    || page.$route.query.lang
                    || localStorage.getItem("language");

        if(!lang){
            lang = window.navigator.language || window.navigator.languages[0];
        }

        if(I18nUtils.langList.find(item => item.id == lang)) {
            I18nUtils.setLanguage(page, lang);
            return;
        }

        lang = lang.slice(0,2);
        if(I18nUtils.langList.find(item => item.id == lang)) {
            I18nUtils.setLanguage(page, lang);
            return;
        }

        I18nUtils.setLanguage(page, "en");
    }


    static setLanguage(page, lang) {
        page.$i18n.locale = lang;
        localStorage.setItem("language", lang);
        I18nUtils.updateDivLanguage(lang);
    }

    static updateDivLanguage(lang){
        const avaiableLang = ['zh', 'en'];
        if(lang != 'zh') lang = 'en'; // 增加其他语言要修改这里
        
        let div = document.getElementById("i18n");
        if(div) div.className = lang;

        document.querySelectorAll(".i18n").forEach(ele => {
            ele.classList.remove('zh');
            ele.classList.remove('en');
            ele.classList.add(lang);
        })
    }
}


// WEBPACK FOOTER //
// ./src/utils/i18nUtils.js